import axios from './axios'
// import qs from "qs";

function service(endpoint) {


    function fetchRoles(id) {
        return axios.get(`${endpoint}/role-tree/${id}`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function saveRoles(id, data = {}) {
        return axios.post(`${endpoint}/role-tree/${id}`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchRoles,
        saveRoles
    }
}

export default service
